// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "audio[data-v-5ff22065]{max-width:100%}.vue-inline-audio[data-v-5ff22065]{font-size:0}.vue-inline-audio__main-part[data-v-5ff22065]{font-size:18px}.inline_audio_container[data-v-5ff22065]{margin-top:30px;margin-bottom:0px}\n", ""]);
// Exports
module.exports = exports;
